import { render, staticRenderFns } from "./confirmUser.vue?vue&type=template&id=c6dba1d0"
import script from "./confirmUser.vue?vue&type=script&lang=js"
export * from "./confirmUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports